import * as React from 'react';
import { Button, Icon, Row, Col } from 'antd';

import { ToastNotifications } from 'src/core/ui/toast';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { ConfigurationService } from "src/core/services/configuration.service";
import { UserEditorController } from "src/app/general/users/parts/user-editor.controller";
import { LanguageEditorController } from "src/app/general/language/parts/language-editor.controller";
import { UploadView } from 'src/core/ui/upload.view';

interface CustomTemplateFormViewParams extends ComponentViewProps<ICustomTemplateItem> {
	mode: ControlMode;
	fileChanged: (file: File) => void;
	templateName: string;
	showUserCombo: boolean;
}

export class CustomTemplateFormView extends React.Component<CustomTemplateFormViewParams, any>{

	render() {
		return (
			<Row>
				{
					this.props.showUserCombo &&
					<Col xs={24} lg={8}>
						<UserEditorController
							required
							onChanged={(newVal) => {
								this.props.model.userId = newVal ? newVal.id : undefined;
								this.props.model.userName = newVal ? newVal.userName : undefined;
							}}
							setBusy={this.props.setBusy}
							label={"User"}
							isRole={false}
							selectFirst={this.props.model.id == undefined}
							mode={this.props.mode}
							value={this.props.model.userId} />
					</Col>
				}
				<Col xs={24} lg={8}>
					<LanguageEditorController required onChanged={(newVal) => this.props.model.languageCode = newVal}
						setBusy={this.props.setBusy}
						label={"Language"}
						mode={this.props.mode}
						value={this.props.model.languageCode} />
				</Col>
				<Col xs={24} lg={8}>
					<UploadView
						label="File"
						value={this.props.templateName}
						mode={this.props.mode}
						onChange={this.props.fileChanged}
					/>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/parts/custom-template-form.view.tsx